import { fetchFamilyFeatures } from '@gn-audio/core/api/product-catalogue/fetch-family-features';
import { fetchGroupFeatures } from '@gn-audio/core/api/product-catalogue/fetch-group-features';
export var fetchFeatures = function (productId, productType) {
    if (productType === void 0) { productType = "f" /* Family */; }
    var promise;
    switch (productType) {
        case "g" /* Group */:
            promise = fetchGroupFeatures(productId);
            break;
        case "f" /* Family */:
        default:
            promise = fetchFamilyFeatures(productId);
            break;
    }
    return promise;
};
